import { useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";
import generateQrCodeOptions from "../utils/generateQrCodeOptions";

const useQRCodeGenerator = (data, type, options) => {
    const qrCodeRef = useRef(null);
    const qrCode = useRef(null);
    const appSiteUrl = process.env.REACT_APP_SITE_URL;

    useEffect(() => {
        qrCode.current = new QRCodeStyling({
            width: 300,
            height: 300,
            ...generateQrCodeOptions(data, type, options, appSiteUrl)
        });

        if (qrCodeRef.current) {
            qrCode.current.append(qrCodeRef.current);
        }
    }, [data, type, options, appSiteUrl]);

    useEffect(() => {
        const updateQRCode = () => {
            const newOptions = generateQrCodeOptions(data, type, options, appSiteUrl);
            qrCode.current.update(newOptions);
        };

        updateQRCode();
    }, [data, type, options, appSiteUrl]);

    return qrCodeRef;
};

export default useQRCodeGenerator;